import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-spec-form",
  templateUrl: "./product-spec-form.component.html",
  styleUrls: ["./product-spec-form.component.scss"],
})
export class ProductSpecFormComponent {
  @Input() form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService
  ) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-spec-form/product-spec-form.component.ts